import { Tags } from "../../Tags/shared/Tags.js";
import { useUserGroups } from "../hooks/useUserGroups.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Users/shared/UserGroupTags.tsx
function UserGroupTags({ userGroupIds, ...tagsProps }) {
	const { data } = useUserGroups({ idFilter: userGroupIds });
	if (data) return /* @__PURE__ */ jsx(Tags, {
		subtle: true,
		tags: data.userGroups,
		...tagsProps
	});
	return null;
}
//#endregion
export { UserGroupTags };

//# sourceMappingURL=UserGroupTags.js.map